module.exports = __webpack_public_path__ + "img/thumb_06.08c950e1.jpg";